import { apiLogger } from '@hooks/use-logger';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { FetchBaseQueryArgs } from '@reduxjs/toolkit/src/query/fetchBaseQuery';
import type { RootState } from '@store/root-reducer';
import { baseQueryRequest } from '@utils/base-query-request';
import { setWidgetSessionHeaders } from '@utils/session';

const prepareHeaders: FetchBaseQueryArgs['prepareHeaders'] = async (headers) => {
    await setWidgetSessionHeaders(headers);
};
const baseQuery = fetchBaseQuery({ prepareHeaders });

const baseQueryWithInterceptor: ReturnType<typeof fetchBaseQuery> = async (
    args,
    api,
    extraOptions,
) => {
    const state = api.getState() as RootState;

    const result = await baseQueryRequest({
        state,
        baseQuery,
        args,
        api,
        extraOptions,
        isUseCredentials: false,
        prepareHeaders,
    });

    if (result.error) {
        await apiLogger(state, result);
    }

    return result;
};

export const sdkApi = createApi({
    reducerPath: 'sdkApi',
    baseQuery: baseQueryWithInterceptor,
    endpoints: () => ({}),
});
